let url = "";

if (process.env.NODE_ENV === "development") {
    url = "http://localhost:8000";
} else if (process.env.REACT_APP_STAGE === 'homolog') {
    url = "https://api-dev.clientela.app";
} else {
    url = "https://api.clientela.app";
}

export const Constants = {
    url: url,
    baseUrl: url + "/api/admin",
};
